module.exports = __webpack_public_path__ + "static/media/jump-page-mobile-pl.2c8e48b8.png";